import React from "react";
import { Table } from "react-bootstrap";

const formatCutOffTime = (time) => {
  if (!time) return "-";
  const [h, m] = time.split(":");
  const hour = parseInt(h, 10);
  const suffix = hour >= 12 ? "PM" : "AM";
  const hour12 = hour % 12 === 0 ? 12 : hour % 12;
  return `${hour12}:${m} ${suffix}`;
};

const formatCutOffDate = (date) => {
  if (!date) return "-";
  return new Date(date).toLocaleDateString("en-CA", { timeZone: "Africa/Lagos" });
};

const CutOffTimesTable = ({ cutOffTimes }) => {
  return (
    <div className="list-body">
      <div className="list-scroll">
        <Table hover className="my-3" id="cutoff-table">
          <thead>
            <tr style={{ fontWeight: "600" }} className="mb-2">
              <th style={{ fontWeight: "600" }} className="pb-3">
                Days
              </th>
              <th style={{ fontWeight: "600" }} className="pb-3">
                Time
              </th>
              <th style={{ fontWeight: "600" }} className="pb-3">
                Start Date
              </th>
              <th style={{ fontWeight: "600" }} className="pb-3">
                End Date
              </th>
            </tr>
          </thead>
          <tbody>
            {cutOffTimes.map((row) => (
              <tr
                key={row.day}
                style={{
                  fontSize: "14px",
                  fontWeight: "400",
                  color: "#333333",
                }}
              >
                <td style={{ paddingTop: "15px", paddingBottom: "15px" }}>
                  {row.day.charAt(0).toUpperCase() + row.day.slice(1)}
                </td>
                <td style={{ paddingTop: "15px", paddingBottom: "15px" }}>
                  {formatCutOffTime(row.cutOffTime)}
                </td>
                <td style={{ paddingTop: "15px", paddingBottom: "15px" }}>
                  {formatCutOffDate(row.startDate)}
                </td>
                <td style={{ paddingTop: "15px", paddingBottom: "15px" }}>
                  {formatCutOffDate(row.endDate)}
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>
    </div>
  );
};

export default CutOffTimesTable;
